module.exports = __webpack_public_path__ + "static/media/bg-aprendiz.763bc84a.svg";